<div class="formElementWrapper">
	<div
		#datepickerPositionTarget
		class="inputWrapper"
	>
		<div class="d-flex filter-input-group px-2">

			<!-- DayPicker -->
			<ng-container *ngIf="calendarMode !== calendarModeEnum.MONTH">

				<!-- Input -->
				<input
					#datepicker="ngbDatepicker"
					class="form-control"
					type="text"
					value="{{ dayPickerControlValue | dateLocaleFormat: dateInputFormat : null }}"
					[id]="id ? id : defaultFilterData.filterId"
					[placeholder]="getI18nString( false, placeholder ? placeholder : defaultFilterData.i18nPath + '.placeholder')"
					[readOnly]="readOnly"
					ngbDatepicker
					[maxDate]="maxDateDayCalendarMode"
					[minDate]="minDateDayCalendarMode"
					[placement]="'bottom-end top-end bottom top bottom-start top-start'"
					[positionTarget]="datepickerPositionTarget"
					(click)="setDate(datepicker)"
					(dateSelect)="onChange($event)"
				>

				<!-- Actions -->
					<ng-container
						[ngTemplateOutletContext]="{
							'datepicker': datepicker,
							'calendarMode': calendarModeEnum.DAY
						}"
						[ngTemplateOutlet]="actionsTpl"
					></ng-container>
			</ng-container>

			<!-- MonthPicker -->
			<ng-container *ngIf="calendarMode === calendarModeEnum.MONTH">
				<input
					class="form-control"
					type="text"
					value="{{ monthPickerControlValue | dateLocaleFormat: dateInputFormat : null }}"
					[id]="id ? id : defaultFilterData.filterId"
					[placeholder]="getI18nString( false, placeholder ? placeholder : defaultFilterData.i18nPath + '.placeholder')"
					[readOnly]="readOnly"
					(click)="toggleMonthPicker()"
				>

				<!-- Actions -->
				<ng-container
					[ngTemplateOutletContext]="{
						'calendarMode': calendarModeEnum.MONTH
					}"
					[ngTemplateOutlet]="actionsTpl"
				></ng-container>
			</ng-container>
		</div>
	</div>
</div>

<!-- ######################### TEMPLATES ######################### -->
<!-- Actions -->
<ng-template
	#actionsTpl
	let-calendarMode="calendarMode"
	let-datepicker="datepicker"
>
	<div class="d-flex input-actions">
		<!-- Calendar Icon -->
		<div
			*ngIf="calendarMode !== calendarModeEnum.MONTH && datepicker"
			class="cursor-pointer"
			(click)="setDate(datepicker)"
		>
			<i class="input-group-text icon-calendar"
			></i>
		</div>

		<!-- Calendar MonthPicker -->
		<div *ngIf="calendarMode === calendarModeEnum.MONTH" class="pt-2">
			<app-month-picker
				#monthPicker
				[maxDate]="maxDate"
				[minDate]="minDate"
				[selectedDate]="monthPickerControlValue"
				(selectedMonthDateEmitter)="setSelectedDate($event)"
			>
			</app-month-picker>
		</div>
	</div>
</ng-template>
